import { render, staticRenderFns } from "./SnapshopIntegrator.vue?vue&type=template&id=b710306c&scoped=true&"
import script from "./SnapshopIntegrator.vue?vue&type=script&lang=js&"
export * from "./SnapshopIntegrator.vue?vue&type=script&lang=js&"
import style0 from "./SnapshopIntegrator.vue?vue&type=style&index=0&id=b710306c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b710306c",
  null
  
)

export default component.exports